export default (clientHttp, apiVersion) => ({
  read(query) {
    return clientHttp.get(`${apiVersion}/photos${query}`)
  },
})
